<template>
  <div @click="follow" v-show="!isFollowing" class="follow_button">
    {{ $t('followAction2') }}
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { api } from '@/api/appGatewayServerApi'
import { showGenericNetworkError, sendApiWarning } from '@/utils/handle_error'

@Component
export default class FollowButton extends Vue {
  @Prop()
  targetVliveId!: string

  @Prop({ default: false })
  isFollowing!: boolean

  @Emit('followStateChanged')
  onFollowStateChanged(value: boolean) {
    return value
  }

  async follow() {
    try {
      await api().streamer.follow._({ targetVliveId: this.targetVliveId })
      this.onFollowStateChanged(true)
    } catch (e) {
      sendApiWarning(e)
      showGenericNetworkError()
    }
  }
}
</script>

<style scoped>
.follow_button {
  height: 24px;
  border-radius: 13px;
  color: #ffffff;
  background-color: #188dff;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  line-height: 16px;
  cursor: hand, pointer;
}

.follow_button:hover {
  opacity: 0.6;
}
</style>
